import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { privacyContent } from '../../data/privacyContent';

const PrivacyPolicy = () => {
  return <LegalPageLayout title="Privacy Policy" content={privacyContent} />;
};

export default PrivacyPolicy; 